import React from "react";
import toast from "react-hot-toast";
import generatePDF, { Resolution, Margin, Options } from "react-to-pdf";

const useTemplateDomToPdf = () => {
  const [loading, setLoading] = React.useState(false);

  const makePdf = async (dom: HTMLElement, options?: Options) => {
    if (dom === null) {
      toast.error("No data to generate PDF");
      return;
    }

    const pdfOpt = { ...OPTIONS, ...options };
    setLoading(true);
    try {
      const pdf = await generatePDF(() => dom, pdfOpt);
      setLoading(false);
      return pdf;
    } catch (error) {
      setLoading(false);
      toast.error("Error generating PDF");
    }
  };

  return {
    makePdf,
    loading
  };
};

export default useTemplateDomToPdf;

export const OPTIONS: Options = {
  method: "save",
  resolution: Resolution.LOW,

  page: {
    margin: Margin.MEDIUM,
    format: "letter",
    orientation: "portrait"
  },
  canvas: {
    mimeType: "image/png",
    qualityRatio: 1
  },
  overrides: {
    pdf: {
      compress: true
    },
    canvas: {
      useCORS: true
    }
  }
};
